import type {SxProps, Theme} from '@mui/material/styles';
import {borderRadius, colors, fontFamily, fontSize} from '@/styles/tokens';

// Migrated from globals.scss `.nft-button` (base + `:hover` + the two bare-class
// mobile breakpoints). `.form-button .nft-button` compound override — actually fully
// scoped under `.blog-expert-form-wrapper`, not a separate bare rule — migrated into
// blogExpertFormWrapperSx instead.
// Gradient start (#f7943d) has no exact token match — kept literal to preserve
// the current rendered color exactly; the gradient end matches colors.accent.orangeDark.
export const nftButtonSx: SxProps<Theme> = {
    boxShadow: 'none !important',
    // Shared button metrics — must stay in step with the `.nft-button, .transparent-button,
    // .animated-button, .button-bg-primary` block in globals.scss. Same size everywhere,
    // at every breakpoint: 8px radius / 10px 18px padding / 14px text.
    borderRadius: `${borderRadius.md} !important`,
    background: `linear-gradient(90deg, #f7943d 0%, ${colors.accent.orangeDark} 100%) !important`,
    fontFamily: `${fontFamily.heading} !important`,
    textTransform: 'none !important',
    padding: '10px 18px !important', // no exact spacing-token match
    border: `1px solid ${colors.accent.orange} !important`,
    fontSize: `${fontSize[14]} !important`,
    '&:hover': {
        background: 'transparent !important',
        border: `1px solid ${colors.accent.orange} !important`,
        color: `${colors.accent.orange} !important`
    },
    '@media (max-width: 394px) and (min-width: 362px)': {
        width: '100%'
    },
    '@media (max-width: 361px) and (min-width: 319px)': {
        width: '100%'
    }
};
